import { S124gS124m01Component } from './s124g-s124m01.component';

export { S124gModule } from './s124g.module';

export const S124gSubComponentsMap = {
	
};

export const S124gComponentsMap = {
	"s124g-s124m01": S124gS124m01Component
};

export const S124gComponents = [
	S124gS124m01Component
];

